import React from 'react'
import Head from 'next/head'
import { CorporateEventsWrapper } from '../components/corporate-events/styles'
import Hero from '../components/Hero'
import HeaderContent from '../components/corporate-events/HeaderContent'
import HeroImage from '../../public/corporate-events/gs_corporate_events_landing.jpg'
import BrandActivations from '../components/corporate-events/BrandActivations'
import WhyGlamsquad from '../components/corporate-events/WhyGlamsquad'
import Reviews from '../components/corporate-events/Reviews'
import ImageScroll from '../components/ImageScroll'
import FAQ from '../faq'
import BookEvent from '../components/corporate-events/BookEvent'
import imageOne from '../../public/corporate-events/corporate-event-carousel-1.jpeg'
import imageTwo from '../../public/corporate-events/corporate-event-carousel-2.jpeg'
import imageThree from '../../public/corporate-events/corporate-event-carousel-3.jpeg'
import imageFour from '../../public/corporate-events/corporate-event-carousel-4.jpeg'
import imageFive from '../../public/corporate-events/corporate-event-carousel-5.jpeg'
import imageSix from '../../public/corporate-events/corporate-event-carousel-6.jpeg'
import imageSeven from '../../public/corporate-events/corporate-event-carousel-7.jpeg'
import imageEight from '../../public/corporate-events/corporate-event-carousel-8.jpeg'
import imageNine from '../../public/corporate-events/corporate-event-carousel-9.jpeg'
import imageTen from '../../public/corporate-events/corporate-event-carousel-10.jpeg'
import imageEleven from '../../public/corporate-events/corporate-event-carousel-11.jpeg'
import imageTwelve from '../../public/corporate-events/corporate-event-carousel-12.jpeg'
import imageThirteen from '../../public/corporate-events/corporate-event-carousel-13.jpeg'
import imageFourteen from '../../public/corporate-events/corporate-event-carousel-14.jpeg'
import imageFifteen from '../../public/corporate-events/corporate-event-carousel-15.jpeg'
import { Header2 } from '../styles/Components'

const FAQ_URL = '/faq'
const CANCELLATION_URL = '/faq'

const FAQ_DATA_CORPORATE_EVENTS = [
  {
    id: 1,
    title:
      'Is it possible to book an event outside of the cities listed on your website? ',
    body: `Yes, Glamsquad pros can travel outside of our current service area for an additional fee, which is calculated based on your specific needs. Please submit the inquiry form found on our website or email us at <a href="mailto:events@glamsquad.com">events@glamsquad.com</a> to get a custom quote.`,
  },
  {
    id: 2,
    title: 'What is the Event Cancellation Policy?',
    body: `Our cancellation policy is nonrefundable and ensures that our beauty professionals are compensated for their blocked-off time and commitment. This policy supports the hard work and dedication of our professionals, allowing us to maintain a high standard of service for all clients. Please review the detailed terms <a href='${CANCELLATION_URL}' target='_blank' rel='noopener noreferrer'>here</a> for specific timeframes and associated charges, including the non-refundable deposit required for booking.`,
  },
  {
    id: 3,
    title: 'What services do you provide for events?',
    body: `Glamsquad is experienced in coordinating large groups and corporate events. We can work with you to meet your event's needs. Please email <a href="mailto:events@glamsquad.com">events@glamsquad.com</a> for more information!`,
  },
]

const images = [
  imageOne,
  imageTwo,
  imageThree,
  imageFour,
  imageFive,
  imageSix,
  imageSeven,
  imageEight,
  imageNine,
  imageTen,
  imageEleven,
  imageTwelve,
  imageThirteen,
  imageFourteen,
  imageFifteen,
]

const CorporateEvents = () => {
  const handleClick = () => {
    if (typeof window !== 'undefined') {
      window.location.href = '/events/contact?origin=corporate-events'
    }
  }

  return (
    <>
      <Head>
        <title>Corporate Event Beauty Services | GLAMSQUAD</title>
        <meta name="description" content="On-site beauty suites, VIP glam, and event pop-ups for conferences, brand activations, and employee events. 2,000+ vetted pros, nationwide travel." />
        <link rel="canonical" href="https://glamsquad.com/corporate-events" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Corporate Event Beauty Services | GLAMSQUAD" />
        <meta property="og:description" content="On-site beauty suites, VIP glam, and event pop-ups for conferences, brand activations, and employee events. 2,000+ vetted pros, nationwide travel." />
        <meta property="og:url" content="https://glamsquad.com/corporate-events" />
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: FAQ_DATA_CORPORATE_EVENTS.map((q) => ({
              '@type': 'Question',
              name: q.title,
              acceptedAnswer: { '@type': 'Answer', text: q.body },
            })),
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Service',
            name: 'Corporate Event Beauty Services',
            serviceType:
              'On-site corporate event hair, makeup, and nail services',
            description:
              'On-site beauty suites, VIP glam, and event pop-ups for conferences, brand activations, and employee events.',
            provider: { '@id': 'https://glamsquad.com/#organization' },
            areaServed: { '@type': 'Country', name: 'United States' },
            url: 'https://glamsquad.com/corporate-events',
          })}
        </script>
      </Head>
      <CorporateEventsWrapper>
        <Hero
          className="hero-component"
          image={HeroImage}
          content={<HeaderContent {...{ handleClick }} />}
        />
        <BrandActivations {...{ handleClick }} />
        <WhyGlamsquad {...{ handleClick }} />
        <Reviews />
        <div className="action-header">
          <Header2>Glamsquad in action</Header2>
        </div>
        <ImageScroll
          images={images}
          imageAlt="GLAMSQUAD hair and makeup at a corporate event"
        />
        <FAQ data={FAQ_DATA_CORPORATE_EVENTS} url={FAQ_URL} />
        <BookEvent {...{ handleClick }} />
      </CorporateEventsWrapper>
    </>
  )
}

export default CorporateEvents
